/**
 * "Uncalibrated — lengths not to scale" (spec 2026-08-25-04 §3).
 *
 * A frame with no calibration is a perfectly valid state — people trace first
 * and measure later — but its numbers are *plan units*, not millimetres. The
 * badge is what stops the editor from presenting nominal units as
 * measurements; every readout next to it prints raw units for the same reason.
 */
import { useTranslation } from 'react-i18next'
import { AppIcon } from '../ui/icon'
import { mdiRulerSquare } from '@mdi/js'

export function UncalibratedBadge({ className = '' }: { className?: string }) {
    const { t } = useTranslation('assets')
    return (
        <span
            className={`inline-flex items-center gap-1 rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-medium text-amber-700 dark:text-amber-400 ${className}`}
            data-testid="plan-editor-uncalibrated-badge"
            title={t('planEditor.uncalibrated_hint')}
        >
            <AppIcon path={mdiRulerSquare} size="xs" />
            {t('planEditor.uncalibrated')}
        </span>
    )
}

export default UncalibratedBadge
